export const ELECTION_CATEGORY_CODE = 'ELECTION'

export type PredictionDisplayMode = 'election' | 'versus'

export function resolvePredictionDisplayMode(category?: string | null): PredictionDisplayMode {
  const code = String(category || '').trim().toUpperCase()
  return code === ELECTION_CATEGORY_CODE ? 'election' : 'versus'
}

export function isElectionCategory(category?: string | null): boolean {
  return resolvePredictionDisplayMode(category) === 'election'
}
